/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.svg';
import VideoModal from './videoModal';
import playIcon from '../assets/playIcon.svg';
import Footer from './Footer';
import TestimonialsScroll from './TestimonialScroll';
import UsageSection from './UsageSection';
import SocialMediaSection from './SocialMediaSection';

const Home = () => {
  const navigate = useNavigate();
  const imageRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isMouseMoving, setIsMouseMoving] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
      setIsMouseMoving(true);
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleGetStarted = () => {
    navigate('/explore');
  };

  return (
    <div style={{
      ...styles.container,
      height: 'auto',
      minHeight: '200vh',
      overflow: 'hidden',
      width: '100%',
      maxWidth: '100vw',
      position: 'relative',
      background: '#000',
    }}>
    <div style={styles.logoStrip} className="logoStrip">
          <div
            style={styles.logoContainer}
            onClick={() => navigate('/')}
            className="clickable-logo"
          >
            <img src={logo} alt="DeepNode Logo" style={styles.logo} loading="eager" />
            <h1 style={styles.title}>DeepNode</h1>
          </div>
        </div>
      <div
        className="dot-pattern"
        style={{
          ...styles.dots,
          WebkitMaskImage: `radial-gradient(circle 300px at ${mousePosition.x}px ${mousePosition.y}px, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))`,
          maskImage: `radial-gradient(circle 300px at ${mousePosition.x}px ${mousePosition.y}px, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))`,
          opacity: isMouseMoving ? 1 : 1,
          transition: "opacity 0s ease",
        }}
      ></div>
      <div className="blob-container">
        {/* <div className={`blob blob1 ${isImageVisible ? 'visible' : ''}`}></div> */}
        {/* <div className={`blob blob2 ${isImageVisible ? 'visible' : ''}`}></div> */}
        <div className="blob-overlay"></div>
      </div>
      
      <div style={{
        height: '100%',
        width: '100%',
        overflow: 'auto',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        paddingRight: '0',
        boxSizing: 'border-box',
        WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
      }}>
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          position: 'relative',
          zIndex: 1,
          padding: '20px',
          boxSizing: 'border-box',
          marginBottom: '24px',
          marginTop: '-120px',
        }}>

          <p style={styles.tagline}>
            Search <span style={styles.tagline_slant}>Smarter,</span><br />
            Learn <span style={styles.tagline_slant}>Better</span>
          </p>
          {/* <p style={styles.description}>DeepNode gives a hierarchical view of your search. <br></br>Falling into the rabbit hole made fun and easier.</p> */}
          <p style={styles.description}>
          Web searches can be time-consuming. <br></br>
          AI tools lack structure and visual elements. <br></br><br></br>
          DeepNode provides interactive breakdown of your searches.<br></br>
          allowing you to explore the breadth, dive deep & miss nothing.
          </p>

          <button onClick={handleGetStarted} className="custom-button">
            <span className="button-text">Open Playground</span>
            <span className="arrow-container">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="arrow-icon"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </span>
          </button>
          <button
          onClick={handleOpenModal}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '4px 8px',
            borderRadius: '50px',
            backgroundColor: 'rgba(0, 0, 0)',
            border: '1px solid #00ED41',
            color: '#fff',
            fontFamily: "'Poppins', sans-serif",
            fontSize: '14px',
            fontWeight: '200',
            cursor: 'pointer',
            gap: '4px',
            transition: 'background-color 0.3s ease, transform 0.2s ease',
            margin: '10px',
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#00ED41')}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)')}
        >
          <img
            src={playIcon}
            alt="Play Icon"
            style={{ width: '24px', height: '24px' }}
          />
          Watch How it Works
        </button>
        <VideoModal isOpen={isModalOpen} onClose={handleCloseModal} />
        </div>

        <div 
          ref={imageRef}
          className="feature-section"
          style={{
            marginTop: '-100px',
            // opacity: isImageVisible ? 1 : 0,
            // transform: isImageVisible ? 'translateY(0)' : 'translateY(50px)',
            transition: 'all 1s ease-out',
            padding: '0px 20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            position: 'relative',
            zIndex: 1,
            gap: '3rem',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              width: "100vw",
              background: "rgba(255, 255, 255, 1)",
              // backdropFilter: "blur(10px)",
              // padding: "0px 20px",
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                maxWidth: "1000px",
                gap: "2rem",
                marginTop: "4rem",
                marginBottom: "5rem",
              }}
            >
              <h2 style={styles.featureText}>
                Spend less time{" "}
                <span style={styles.tagline_second}>searching </span> & more time{" "}
                <span style={styles.tagline_second}>understanding</span>
              </h2>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                maxWidth: "65%",
                gap: "2rem",
                padding: "0 20px",
              }}
              className="responsive-section"
            >
              {/* Left Section: Text */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  color: "#141414",
                  fontFamily: "'Poppins', sans-serif",
                  textAlign: "left",
                  lineHeight: "1.6",
                  // maxWidth: ""
                }}
              >
                <h2
                  style={{
                    fontSize: "clamp(20px, 3vw, 28px)",
                    fontWeight: 200,
                    marginBottom: "1rem",
                  }}
                >
                Endless canvas for endless curiosity
                </h2>
                <p
                  style={{
                    fontSize: "clamp(14px, 3vw, 16px)",
                    color: "#141414",
                  }}
                >
                  <b><i>"To understand the parts, you must first break the whole." - Anonymous</i></b>
                  <p>DeepNode provides well structured hierarchical view of your search, broken down to its
                  subtopics. Don't miss the information that matters.</p>
                  <p>Understand the "breadth" about your search & dive deep as your curiosity allows.</p>
                  <p>Search Wide. Dive Deep. Miss Nothing.</p>
                </p>
              </div>

              {/* Right Section: GIF */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={require("../assets/deepnode_intro_2.gif")}
                  alt="Upload Your Sources"
                  style={{
                    width: "100%",
                    maxWidth: "1000px",
                    borderRadius: "12px",
                  }}
                />
              </div>
            </div>
            
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                maxWidth: "65%",
                gap: "2rem",
                padding: "60px 20px",
              }}
              className="responsive-section"
            >
              {/* Left Section: Text */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  color: "#141414",
                  fontFamily: "'Poppins', sans-serif",
                  textAlign: "left",
                  lineHeight: "1.6",
                }}
              >
                <h2
                  style={{
                    fontSize: "clamp(20px, 3vw, 28px)",
                    fontWeight: 200,
                    marginBottom: "1rem",
                  }}
                >
                  Outsource your searches - focus on what matters: <b>learning</b>
                </h2>
                <p
                  style={{
                    fontSize: "clamp(14px, 3vw, 16px)",
                    color: "#141414",
                  }}
                >
                  <b><i>Save hours of searching the "right" info and juggling countless tabs.</i></b>
                  <p>Web sources, images, structured, comprehensive content - all in one place. DeepNode brings together structured content, relevant web sources (articles, videos, PDFs, papers, etc.) and visual elements so you can focus on what matters.</p>
                </p>
              </div>

              {/* Right Section: GIF */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={require("../assets/deepnode_intro_3.gif")}
                  alt="Upload Your Sources"
                  style={{
                    width: "100%",
                    maxWidth: "1000px",
                    borderRadius: "12px",
                  }}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                maxWidth: "65%",
                gap: "2rem",
                padding: "0 20px",
                marginBottom: "5rem",
              }}
              className="responsive-section"
            >
              {/* Left Section: Text */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  color: "#141414",
                  fontFamily: "'Poppins', sans-serif",
                  textAlign: "left",
                  lineHeight: "1.6",
                }}
              >
                <h2
                  style={{
                    fontSize: "clamp(20px, 3vw, 28px)",
                    fontWeight: 200,
                    marginBottom: "1rem",
                  }}
                >
                  AI + Structure + Curiosity = DeepNode
                </h2>
                <p
                  style={{
                    fontSize: "clamp(14px, 3vw, 16px)",
                    color: "#141414",
                  }}
                >
                  Powered by AI & web sources, accompanied with structure, DeepNode is built with an intention to catalyze curiosity.
                  {/* <p>We're dedicated to improving Deepnode by adding new features. Share your feedback here.</p> */}
                </p>
              </div>

              {/* Right Section: GIF */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={require("../assets/deepnode_intro_4.gif")}
                  alt="Upload Your Sources"
                  style={{
                    width: "100%",
                    maxWidth: "1000px",
                    borderRadius: "12px",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <TestimonialsScroll />
        <UsageSection />
        <SocialMediaSection />

      </div>

      <style>
        {`
          /* Hide scrollbar */
          *::-webkit-scrollbar {
            display: none;
          }
          * {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .dot-pattern {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: radial-gradient(circle, rgba(255, 255, 255, 0.17) 1px, transparent 1px);
            background-size: 30px 30px;
            pointer-events: none;
            z-index: 0;
          }

          /* Blob styles */
          .blob-container {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
            z-index: 0;
          }

          .blob {
            position: absolute;
            border-radius: 50%;
            filter: blur(100px);
            mix-blend-mode: screen;
            pointer-events: none;
            transition: all 1.2s ease-in-out;
          }

          .blob1 {
            width: 30%;
            height: 30%;
            background: linear-gradient(128deg, rgba(255, 51, 102, 0.9), rgba(186, 38, 93, 0.3));
            right: 27%;
            bottom: 10%;
          }

          .blob1.visible {
            transform: translate(-120%, -100%) scale(0.5);
          }

          .blob2 {
            width: 40%;
            height: 60%;
            background: linear-gradient(128deg, rgba(65, 88, 208, 0.5), rgba(0, 147, 233, 0.8));
            right: 10%;
            bottom: 20%;
          }

          .blob2.visible {
            transform: translate(-100%, 20%) scale(0.7);
          }

          .feature-section {
            margin: 0 auto;
            max-width: 80%;
            width: 90%
          }

          .custom-button {
            display: flex;
            align-items: center;
            padding: 14px 24px;
            background-color: rgba(0, 0, 0, 0.7);
            backdrop-filter: blur(10px);
            color: #00ED41;
            border: 2px solid #00ED41;
            border-radius: 50px;
            font-family: 'Poppins', sans-serif;
            font-size: 16px;
            font-weight: 400;
            cursor: pointer;
            transition: all 0.2s ease;
            text-decoration: none;
            margin-top: 20px;
          }
          .button-text {
            margin-right: 10px;
            color: #fff;
          }
          .arrow-container {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            background-color: #00ED41;
            border-radius: 50%;
            transition: background-color 0.2s ease;
          }
          .arrow-icon {
            color: #000;
            transition: color 0.2s ease;
          }
          .custom-button:hover {
            background-color: rgba(255, 255, 255);
            color: #fff;
            transition: background-color 0.5s ease;
          }
          .custom-button:hover .button-text {
            color: #000;
          }
          .custom-button:hover .arrow-container {
            background-color: #000;
          }
          .custom-button:hover .arrow-icon {
            color: #00ED41;
          }
          .images-container {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 2rem;
            width: 100%;
            max-width: 1600px;
            padding: 0 20px;
          }

          .image-card {
            flex: 1;
            max-height: 400px;
            aspect-ratio: 9/12;
            padding: 20px;
            background: rgba(18, 18, 18, 0.3);
            backdrop-filter: blur(20px);
            border-radius: 20px;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .image-card:hover {
            transform: translateY(-5px);
            border: 2px solid rgba(255, 255, 255, 0.1);
          }

          .feature-image {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }

          @media (max-width: 768px) {
            .logo-container {
              top: 10px;
              left: 10px;
            }
            .logo {
              width: 30px;
              height: 30px;
            }
            .title {
              font-size: 18px;
            }
          }
          /* Responsive design for smaller screens */
          @media (max-width: 1024px) {
            .images-container {
              flex-direction: column;
              gap: 1.5rem;
            }

            .image-card {
              width: 100%;
              max-width: 500px;
            }
          }
          /* Mobile-optimized styles */
          @media (max-width: 768px) {
            .feature-section {
              padding: 20px 10px;
              gap: 2rem;
            }

            .images-container {
              padding: 0 10px;
              gap: 1rem;
            }

            .image-card {
              padding: 15px;
              aspect-ratio: 3/4;
            }

            .custom-button {
              padding: 12px 20px;
              font-size: 14px;
            }

            .button-text {
              margin-right: 8px;
            }

            .arrow-container {
              width: 20px;
              height: 20px;
            }

            .blob1 {
              width: 50%;
              height: 50%;
              opacity: 0.7;
            }

            .blob2 {
              width: 60%;
              height: 70%;
              opacity: 0.7;
            }
          }

          /* Prevent text scaling on iOS */
          @media screen and (max-width: 768px) {
            body {
              -webkit-text-size-adjust: none;
            }
          }

          /* Optimize touch targets */
          @media (hover: none) and (pointer: coarse) {
            .custom-button {
              min-height: 44px;
              min-width: 44px;
            }

            .image-card {
              min-height: 44px;
            }
          }

          /* Reduce motion for users who prefer it */
          @media (prefers-reduced-motion: reduce) {
            .blob, .feature-section, .custom-button, .image-card {
              transition: none !important;
              animation: none !important;
            }
          }

          /* Optimize images for different screen densities */
          @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
            .feature-image {
              image-rendering: -webkit-optimize-contrast;
            }
          }

          /* Styles for intersection section */
          @media (max-width: 1024px) {
            .intersection-section {
              padding: 40px 20px;
            }
            .intersection-content {
              flex-direction: column;
              gap: 2rem;
            }
            .intersection-description,
            .intersection-image {
              width: 100%;
              max-width: none;
            }
          }

          @media (max-width: 768px) {
            .intersection-section {
              padding: 30px 10px;
            }
            .intersection-description ul {
              gap: 0.75rem;
            }
            .intersection-description li {
              font-size: 14px;
            }
          }

          @media (prefers-reduced-motion: reduce) {
            .intersection-section {
              animation: none;
              opacity: 1;
              transform: none;
            }
          }
          
          .screenshot-section {
            opacity: 0;
            transform: translateY(30px);
            animation: fadeInUp 1s ease-out forwards;
            animation-delay: 0.5s;
            width: 100%;
            max-width: 1400px;
            margin: 0 auto;
          }

          .screenshot-container {
            position: relative;
            width: 90%;
            max-width: 1200px;
            margin: 0 auto;
            border-radius: 20px;
            overflow: hidden;
            background: rgba(18, 18, 18, 0.3);
            backdrop-filter: blur(20px);
            padding: 20px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            transition: transform 0.3s ease;
          }

          .screenshot-wrapper {
            position: relative;
            width: 100%;
            padding-top: 56.25%; /* 16:9 aspect ratio */
            border-radius: 12px;
            overflow: hidden;
          }

          .screenshot-container:hover {
            transform: translateY(-5px);
          }

          .app-screenshot {
            width: 100%;
            height: auto;
            display: block;
            object-fit: cover;
            object-position: center;
            border-radius: 12px;
          }

          .screenshot-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0.1) 100%
            );
            pointer-events: none;
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          /* Responsive styles for screenshot section */
          @media (max-width: 768px) {
            .screenshot-section {
              padding: 40px 10px;
            }

            .screenshot-container {
              padding: 10px;
              margin: 0 10px;
            }
          }

          /* Optimize performance */
          @media (prefers-reduced-motion: reduce) {
            .screenshot-section {
              animation: none;
              opacity: 1;
              transform: none;
            }
          }
          .responsive-section {
            flex-direction: row;
          }

          /* Responsive layout for smaller screens */
          @media (max-width: 768px) {
          .responsive-section {
            display: flex;
            flex-direction: column !important; /* Stack elements */
            text-align: center; /* Center text for smaller screens */
            gap: 1rem; /* Reduce spacing */
            padding: 0 20px;
            width: 100px;
            maxWidth: 105px;
          }

          .responsive-section img {
            max-width: 100%; /* Make image take full width */
            height: auto; /* Maintain aspect ratio */
          }

          .responsive-section div {
            align-items: center; /* Center text alignment */
            justify-content: center;
          }

          .logoStrip {
            height: 10px;
          }
        }
        `}
      </style>
      <Footer />
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
  },
  dots: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage:
      "radial-gradient(circle, rgba(255, 255, 255, 0.8) 1px, transparent 1px)",
    backgroundSize: "30px 30px",
    pointerEvents: "none",
    zIndex: 0,
  },
  logoStrip: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '70px', // Adjust as per the logo height
    background: 'rgba(0, 0, 0, 0.7)',
    backdropFilter: 'blur(20px)',
    zIndex: 1000, 
    // boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)', // Optional shadow
  },
  logoContainer: {
    position: "absolute",
    top: "7px",
    left: "25px",
    display: "flex",
    alignItems: "center",
    gap: "15px",
    zIndex: 1010,
    cursor: "pointer",
  },
  logo: {
    width: '35px',
    height: '35px',
    objectFit: 'contain',
  },
  title: {
    fontSize: 'clamp(20px, 3vw, 20px)',
    color: '#fff',
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 400,
    // textShadow: '0 2px 4px rgba(0,0,0,0.3)',
  },
  highlightText: {
    color: '#00ED41',
    fontWeight: 500,
  },
  footer: {
    position: 'fixed',
    bottom: '20px',
    textAlign: 'center',
    fontSize: '14px',
    color: '#bbb',
    fontFamily: "'Poppins', sans-serif",
    zIndex: 10,
    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
  },
  link: {
    color: '#0066cc',
    textDecoration: 'none',
  },
  tagline: {
    fontSize: 'clamp(40px, 5vw, 70px)', // Responsive font size
    color: '#fff',
    lineHeight: '1.2', // Adjusted for better alignment
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 450,
    textAlign: 'center', // Ensure centered alignment
    display: 'inline-block', // Keep inline flow
  },
  tagline_slant: {
    fontSize: 'clamp(45px, 5vw, 75px)', // Same font size for consistency
    fontStyle: 'italic',
    color: '#fff',
    fontFamily: "'EB Garamond', serif",
    fontWeight: 450,
    lineHeight: '1.2', // Match with tagline
  },
  tagline_second: {
    fontSize: "clamp(24px, 4vw, 32px)", // Adjust size based on device
    fontStyle: 'italic',
    color: '#000',
    fontFamily: "'EB Garamond', serif",
    fontWeight: 500,
    marginBottom: '26px', // Space between tagline and search bar
    textAlign: 'center',
    width: '140%',
  },
  description: {
    fontSize: 'clamp(12px, 4vw, 18px)', // Responsive font size
    color: '#ccc',
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 400,
    marginTop: '-20px',
    marginBottom: '32px',
    maxWidth: 'clamp(280px, 80%, 90%)',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    textShadow: '0 2px 4px rgba(0,0,0,1)',
    textAlign: 'center',
    padding: '0 20px',
  },
  featureText: {
    fontSize: "clamp(20px, 4vw, 32px)", // Responsive font size
    color: "#000", // Default text color
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    textAlign: "center",
    maxWidth: "90%",
    margin: "0 auto",
    // textShadow: "0 2px 4px rgba(0,0,0,0.3)",
    lineHeight: 1.4,
  },
  gradientText: {
    background: "linear-gradient(90deg, #00C9FF, #92FE9D)", // Gradient colors
    WebkitBackgroundClip: "text", // Clip the background to the text
    WebkitTextFillColor: "transparent", // Make the text itself transparent
    fontWeight: 500, // Emphasize the gradient text
  },
  card: {
    border: '2px solid #cccccc',
    background: 'rgba(0, 0, 0, 0.7)',
    backdropFilter: 'blur(20px)',
    padding: '30px',
    borderRadius: '15px',
    // boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    textAlign: 'left',
  },
  cardIcon: {
    width: '32px',
    height: '32px',
    marginBottom: '5px',
  },
  cardTitle: {
    fontSize: 'clamp(18px, 2.5vw, 24px)',
    fontWeight: 400,
    color: '#fff ',
    marginBottom: '10px',
    marginTop: '10px',
    // textShadow: '0 2px 4px rgba(0,0,0,0.3)',
  },
  cardContent: {
    fontSize: 'clamp(14px, 2vw, 16px)',
    color: '#ddd',
    lineHeight: 1.6,
    margin: 0
  },
};

export default Home;
